import React from 'react'
import { useTranslation } from 'react-i18next'
import AppInput from 'components/ui/AppInput'
import AppCheckbox from 'components/ui/AppCheckbox'
import SaveBackButton from 'components/ui/SaveBackButton'

const HiddenDiv = ({ as = "update" }) => {
  return (
    <>
    {as !== "modal" ? <div className='md:block w-0 h-0'/> : null}
    </>
  )
}

const ModifierForm = ({
  modifier,
  handleBasicInfo = () => {},
  handleValues = () => {},
  onSave = () => {},
  updatePrice = () => {},
  showBackButton = true,
  as = "update",
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative h-full flex flex-col gap-4">
      <div className='flex-1'>
     <form id="createModifierForm" className={`relative grid gap-4 ${as === "modal" ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"}`}>
        <AppInput
          label={t("Name")}
          value={modifier?.values?.baseLanguage?.name}
          onInput={(e) => handleBasicInfo("name", e.target.value)}
          mandatory={true}
          error={modifier?.errors?.baseLanguage?.name}
          placeholder={t("Enter Modifier Name")}
        />
       <HiddenDiv as={as} />
        <AppInput
          label={t("Price") + " (" + t("AED") + ")"}
          value={modifier?.values?.price}
          onInput={(e) => handleValues("price", e.target.value)}
          mandatory={true}
          error={modifier?.errors?.price}
          placeholder={t("Enter Modifier Price")}
        />
        <HiddenDiv as={as} />
        <AppInput
          label={t("Maximum Order Quantity")}
          value={modifier?.values?.maximumOrderQuantity}
          onInput={(e) => updatePrice("maximumOrderQuantity", e.target.value)}
          mandatory={true}
          error={modifier?.errors?.maximumOrderQuantity}
          placeholder={t("Enter Maximum Order Quantity")}
        />
        <HiddenDiv as={as} />
        <AppInput
          label={t("SKU (Stock Keeping Unit)")}
          value={modifier?.values?.sku}
          onInput={(e) => handleValues("sku", e.target.value)}
          mandatory={false}
          error={modifier?.errors?.sku}
          placeholder={t("Enter SKU")}
        />
        <HiddenDiv as={as} />
        <AppCheckbox
          className="mb-3"
          label={t("Stock Management")}
          checked={modifier.values.isStockEnabled}
          onChange={() =>
            handleValues("isStockEnabled", !modifier.values.isStockEnabled)
          }
        />
        {modifier.values.isStockEnabled && (
          <>
            <AppInput
              label={t("In Stock Quantity")}
              value={modifier.values.availableStock}
              onInput={(e) => handleValues("availableStock", e.target.value)}
              mandatory={true}
              error={modifier.errors.availableStock}
              placeholder={t("Enter Available Stock")}
            />
            <AppInput
              label={t("Low Stock Threshold")}
              value={modifier.values.lowStockThreshold}
              onInput={(e) => handleValues("lowStockThreshold", e.target.value)}
              mandatory={false}
              error={modifier.errors.lowStockThreshold}
              placeholder={t("Enter Low Stock Threshold")}
            />
          </>
        )}
      </form>
      </div>
      <SaveBackButton showBackButton={showBackButton} onSave={onSave} />
    </div>
  )
}

export default ModifierForm